export default "__VITE_ASSET__8HkQE6jA__"